import {useEffect, useState} from "react";

import {useAppSelector} from "../../store/hooks";
import {ApplicationModalArray} from "./ApplicationModalArray";

const MODAL_CLOSE_TIMEOUT = 200;

export function LeadModal() {
    const {isModalOpen} = useAppSelector((state) => state.mainLead);
    const [shouldRenderModal, setShouldRenderModal] = useState(isModalOpen);

    useEffect(() => {
        if (isModalOpen) {
            setShouldRenderModal(true);
            return;
        }

        const timeoutId = setTimeout(() => {
            setShouldRenderModal(false);
        }, MODAL_CLOSE_TIMEOUT);

        return () => clearTimeout(timeoutId);
    }, [isModalOpen]);

    return shouldRenderModal ? <ApplicationModalArray /> : null;
}
import {useEffect, useState} from "react";

import {useAppSelector} from "../../store/hooks";
import {ApplicationModalArray} from "./ApplicationModalArray";

const MODAL_CLOSE_TIMEOUT = 200;

export function LeadModal() {
    const {isModalOpen} = useAppSelector((state) => state.mainLead);
    const [shouldRenderModal, setShouldRenderModal] = useState(isModalOpen);

    useEffect(() => {
        if (isModalOpen) {
            setShouldRenderModal(true);
            return;
        }

        const timeoutId = setTimeout(() => {
            setShouldRenderModal(false);
        }, MODAL_CLOSE_TIMEOUT);

        return () => clearTimeout(timeoutId);
    }, [isModalOpen]);

    return shouldRenderModal ? <ApplicationModalArray /> : null;
}
